"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _flux = require("flux");

var VIEW_ACTION = 'VIEW_ACTION';
var dispatcher = new _flux.Dispatcher();

dispatcher.handleViewAction = function handleViewAction(action) {
  this.dispatch({
    source: VIEW_ACTION,
    action: action,
    // ensures that `handleViewAction` actions are compatible with GeneralStore
    actionType: action.actionType || ''
  });
};

var _default = dispatcher;
exports.default = _default;
module.exports = exports.default;